// Function that loads recaptcha on form input focus
function reCaptchaOnFocus() {
  // eslint-disable-next-line camelcase, no-undef
  if (!wpcf7_recaptcha || !wpcf7_recaptcha.sitekey || !wpcf7_recaptcha.moduleScript) {
    document.querySelectorAll('.wpcf7-form-control').forEach((element) => element.removeEventListener('focus', reCaptchaOnFocus));
    return;
  }

  const head = document.getElementsByTagName('head')[0];
  const script = document.createElement('script');
  script.type = 'text/javascript';
  // eslint-disable-next-line camelcase, no-undef
  script.src = `https://www.google.com/recaptcha/api.js?render=${wpcf7_recaptcha.sitekey}`;
  script.onload = function () {
    const moduleScript = document.createElement('script');
    moduleScript.type = 'text/javascript';
    // eslint-disable-next-line camelcase, no-undef
    moduleScript.src = wpcf7_recaptcha.moduleScript;
    head.appendChild(moduleScript);
  };
  head.appendChild(script);

  // remove focus to avoid js error:
  document.querySelectorAll('.wpcf7-form-control').forEach((element) => element.removeEventListener('focus', reCaptchaOnFocus));
}
window.document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wpcf7-form-control').forEach((element) => element.addEventListener('focus', reCaptchaOnFocus, false));
});
